import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { DialogLayoutAuraComponent } from '@workspace/ng-aura';

export type PropertyMissingOwnershipDialogResult = 'upload_now' | 'upload_later';

@Component({
  selector: 'etxe-property-missing-ownership-dialog',
  standalone: true,
  imports: [CommonModule, MatButtonModule, MatIconModule, MatDialogModule, DialogLayoutAuraComponent],
  templateUrl: './property-missing-ownership-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PropertyMissingOwnershipDialogComponent {
  readonly dialogRef = inject(
    MatDialogRef<PropertyMissingOwnershipDialogComponent, PropertyMissingOwnershipDialogResult>,
  );

  onUploadNow(): void {
    this.dialogRef.close('upload_now');
  }

  onUploadLater(): void {
    this.dialogRef.close('upload_later');
  }
}
